<template>
<layout-content :style="{
  '--manual-layout-grid-columns': `${compareTableVisible ? 'auto' : 0} ${$slots.displayChart ? '10px' : ''} ${compareChartVisible ? `${compareTableVisible ? compareChartWidth : 'auto'}` : '0'}`,
  '--manual-layout-grid-rows': `auto${filterAuditRuleCategories.length > 0 ? ' 50px ' : ' '} ${compareTableVisible ? '350px' : 0}`,
  '--manual-layout-grid-row-gap': filterAuditRuleCategories.length > 0 ? '5px' : '0',
  '--row-span': `1/${3 + (filterAuditRuleCategories.length > 0)}`
}">
  <template #headerTitle>
    <el-button
      icon="el-icon-back"
      size="small"
      style="float:left;"
      @click="onBackBtnClick"
    >返回上一级</el-button>

    <h1 class="layout-content-header-text" style="margin-left:.5em;">{{site.name}} / {{auditSiteDevice.name}} / {{ stage === -1 >>> 1 ? '月度审核' : '数据 ' + numberToCN[stage] + ' 审' }}</h1>

    <el-date-picker
      v-if="(stage <= 1 || (stage > 1 && !hasAuditBtn)) && stage !== -1 >>> 1"
      v-model="conditions.auditTime"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd"
      :clearable="false"
      :editable="false"
      size="small"
      style="width:170px;margin-left:2rem;"
      @change="onAuditTimeChanged"
    />

    <el-date-picker
      v-if="stage === -1 >>> 1"
      v-model="conditions.auditTime"
      type="month"
      value-format="yyyy/MM/dd"
      :clearable="false"
      :editable="false"
      size="small"
      style="width:170px;margin-left:2rem;"
      @change="onMonthAuditBtnClick"
    />

    <el-date-picker
      v-if="stage > 1 && hasAuditBtn && stage !== -1 >>> 1"
      v-model="conditions.beginTime"
      :picker-options="startDatePickerOptions"
      :clearable="false"
      :editable="false"
      placeholder="开始时间"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd 00:00:00"
      size="small"
      style="width:170px;margin-left:2rem;"
      @change="onAuditTimeChanged('range')"
    />
    <span v-if="stage > 1 && hasAuditBtn && stage !== -1 >>> 1">～</span>
    <el-date-picker
      v-if="stage > 1 && hasAuditBtn && stage !== -1 >>> 1"
      v-model="conditions.endTime"
      :picker-options="endDatePickerOptions"
      :clearable="false"
      :editable="false"
      placeholder="结束时间"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd 23:59:59"
      size="small"
      style="width:170px;"
      @change="onAuditTimeChanged('range')"
    />
  </template>

  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        type="success"
        icon="el-icon-monitor"
        size="small"
        @click="onFullScreenBtnClick"
      >{{showSideNav ? '全屏' : '恢复'}}显示</el-button>

      <el-button
        v-if="defectData.length > 0 && stage <= 1 && hasAuditBtn"
        type="warning"
        icon="el-icon-warning-outline"
        size="small"
        @click="openNoDataEditor"
      >
        数据缺失
      </el-button>
      <el-button
        v-if="(hasAuditBtn || (stage === -1 >>> 1)) && !monthAuditDataMap[new Date(conditions.auditTime).format('YYYY/MM')]"
        :disabled="selectedFactorIds.length === 0"
        type="primary"
        icon="el-icon-s-operation"
        size="small"
        @click="onBatchProcessBtnClick"
      >批量处理</el-button>

      <el-button
        v-if="stage === -1 >>> 1 && !monthAuditDataMap[new Date(conditions.auditTime).format('YYYY/MM')]"
        type="orange"
        icon="el-icon-edit-outline"
        size="small"
        @click="onMonthAuditSubmitBtnClick"
      >
        月审确认
      </el-button>

      <el-button
        v-if="hasAuditBtn && stage !== -1 >>> 1"
        type="orange"
        icon="el-icon-edit-outline"
        size="small"
        @click="onAuditSubmitBtnClick"
      >
        <!-- 提交{{stage >= maxAuditStage ? '终' : numberToCN[stage + 1]}}审 -->
        {{ stage >= maxAuditStage ? '终审确认' : `提交${numberToCN[stage + 1]}审` }}
      </el-button>

      <el-popover
        trigger="click"
        v-if="hasAuditBtn && stage > 1 && timeSpan < 1 && (stage !== -1 >>> 1)"
      >
        <section class="comment-wrapper">
          <el-input
            v-model="errMsg"
            type="textarea"
            :autosize="{minRows: 5}"
            style="width:100%;"
          />
          <el-button
            type="primary"
            size="mini"
            class="comment-btn"
            @click="onBackReAuditBtnClick(errMsg)"
          >确定</el-button>
        </section>
        <el-button
          type="warning"
          slot="reference"
          icon="el-icon-close"
          size="small"
        >退回重审</el-button>
      </el-popover>

      <el-popover
        trigger="click"
        v-if="!hasAuditBtn && isAdmin && stage >= maxAuditStage && (auditSiteDevice || {}).auditStage >= (1 << maxAuditStage) && (stage !== -1 >>> 1)"
      >
        <section class="comment-wrapper">
          <el-input
            v-model="errMsg"
            type="textarea"
            :autosize="{minRows: 5}"
            style="width:100%;"
          />
          <el-button
            type="primary"
            size="mini"
            class="comment-btn"
            @click="onBackAuditedBtnClick"
          >确定</el-button>
        </section>
        <el-button
          type="warning"
          icon="el-icon-close"
          size="small"
          slot="reference"
        >退回重审</el-button>
      </el-popover>
    </section>
  </template>

  <template #body>
    <div style="grid-column:1;">
      <audit-main-grid
        :filter-device-error-factor-ids="filterDeviceErrorFactorIds"
        :qc-status="qcStatus"
        :filter-qc-error-factor-ids="filterQcErrorFactorIds"
        :audit-rule-categories="auditRuleCategories"
        :data-list="dataList"
        :no-data-records="noDataRecords"
        :cause-options="causeOptions"
        :default-unit-prop="defaultUnitProp"
        @selection-change="onSelectionChange"
        @onAuditNumClick="onAuditNumClick"
      />
    </div>

    <div
      v-show="compareTableVisible"
      v-if="filterAuditRuleCategories.length > 0"
      class="audit-tab-bar"
      style="grid-column:1;"
    >
      <ul ref="tab-bar-inner" class="audit-tab-bar-inner">
        <li
          v-for="auditRuleCategory in filterAuditRuleCategories"
          :key="auditRuleCategory.id"
          :title="auditRuleCategory.factorIds ? `共有${auditRuleCategory.factorIds.length}个因子出现${auditRuleCategory.name}情况` : null"
          :class="{
            selected: (selectedTab === auditRuleCategory.id && auditRuleCategory.id === currentRuleId)
          }"
          :style="{
            '--grid-template-rows': auditRuleCategory.factorIds ? '26px max-content' : 'auto'
          }"
          @click="onAuditRuleCategoryClick(auditRuleCategory)"
        >
          <label>{{auditRuleCategory.name}}</label>
          <el-progress
            v-if="auditRuleCategory.factorIds && dataList.length > 0"
            :percentage="Number((auditRuleCategory.factorIds.length / dataList.length * 100).toFixed(0))"
            :show-text="false"
            color="#F56C6C"
          />
        </li>
      </ul>

      <el-dropdown v-if="hideTabs.length > 0" trigger="click" @command="onMoreTabClick">
        <i class="el-icon-caret-bottom more-tabs" style="display:flex;justify-content:center;align-items:center;"></i>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="auditRuleCategory in hideTabs"
            :key="auditRuleCategory.id"
            :command="auditRuleCategory"
          >{{auditRuleCategory.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div style="grid-column:1;" v-show="compareTableVisible">
      <audit-main-chart
        v-if="showMiniChart === 'miniChart'"
        :show-chart="showMiniChart"
        :has-audit-btn="hasAuditBtn"
        :audit-rule-categories="auditRuleCategories"
        :data-list="dataList"
        :data-times="dataTimes"
        :stage="stage"
        :month-audit-data-map="monthAuditDataMap"
        :selected-factor-ids.sync="auditMainChartSelectedFactorIds"
        :selected-list.sync="auditMainChartSelectedList"
        :default-unit-prop="defaultUnitProp"
      />

      <template v-else>
        <slot
          v-for="moreTab in moreTabs"
          v-if="showMiniChart === moreTab.chartType"
          :name="moreTab.chartType"
        />
      </template>
    </div>

    <div v-if="$slots.displayChart" class="compare-chart-ctrl">
      <div>
        <div v-if="compareTableVisible" class="compare-chart-ctrl-btn" @click="onCompareChartCtrlClick">
          <i :class="compareChartVisible ? 'el-icon-caret-right' : 'el-icon-caret-left'"></i>
        </div>
        <div v-if="compareChartVisible" class="compare-chart-ctrl-btn" @click="onCompareTableCtrlClick">
          <i :class="compareTableVisible ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
    </div>

    <div v-if="$slots.displayChart" class="compare-chart-wrapper">
      <slot name="displayChart" />
    </div>
  </template>

  <template #editor>
    <process-panel
      :stage="stage"
      :site-device="auditSiteDevice"
      :audit-rule-categories="auditRuleCategories"
    />

    <batch-process-panel
      :stage="stage"
      :site-device="auditSiteDevice"
      :audit-rule-categories="auditRuleCategories"
      :data-times="dataTimes"
      :data-list="dataList"
    />

    <audit-related-charts-dialog
      :data-list="dataList"
    />

    <el-dialog
      :title="`${auditSiteDevice.name}-数据缺失`"
      :visible.sync="centerDialogVisible"
      width="60%"
      :before-close="saveNoData"
      :show-close="false"
    >
      <div slot="title">
        <div style="float: right;">
          <el-select v-model="manyRatio" size="small" style="width: 150px;" placeholder="请选择缺失原因" v-if="handleSelectionNoDataTime.length !== 0" @change="manyRatioChange">
            <el-option
              v-for="item in causeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button
            v-if="noData.length === 0"
            icon="el-icon-back"
            size="small"
            @click="onBackBtnClick"
          >返回上一级</el-button>
        </div>

        <span class="layout-content-header-text" style="margin-left: 5px;font-weight: bold; font-size: 19px;">{{site.name}} / {{auditSiteDevice.name}}</span>
      </div>
      <div style="width: 100%; height: 500px;display: flex;">
        <el-table
          :data="tableData"
          border
          stripe
          height="100%"
          style="width: 59%"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column prop="dataTime" label="时间" />
          <el-table-column prop="cause" label="缺失原因">
            <template slot-scope="{row}">
              <div style="display: flex;align-items: center;justify-content: left;">
                <el-select v-model="row.cause" size="small" style="width: 200px;" @change="ratioChange">
                  <el-option
                    v-for="item in causeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div
                  :class="row.cause === '' ? 'el-icon-circle-close' : 'el-icon-circle-check'"
                  :style="`color: ${row.cause === '' ? '#F85778' : '#1FC96E'};margin-left: 5px;`"
                ></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="ratioData"
          border
          stripe
          height="100%"
          style="width: 40%;margin-left: 5px;"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
        >
          <el-table-column prop="factorName" label="因子名称" />
          <el-table-column prop="gatherRate" label="捕集率">
            <template slot-scope="{row}">
              {{(row.gatherRate * 100).toFixed(2)+ '%'}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="orange" @click="saveNoData" style="margin-right: 5px;">提 交</el-button>
        <a class="cancel-btn btn" v-if="noData.length !== 0" @click="centerDialogVisible = false">关闭</a>
      </span>
    </el-dialog>

    <el-dialog
      :title="`${auditSiteDevice.name}-${flagName}`"
      :visible.sync="flagDetailDialogVisible"
      width="75%"
    >
      <div style="height:500px;">
        <el-table
          :data="flagDetails"
          border
          stripe
          height="100%"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
        >
          <el-table-column prop="factorName" label="因子名称" />
          <el-table-column prop="dataTime" label="数据时间" />
          <el-table-column prop="value" label="监测值">
            <template slot-scope="{row}">{{ Number.isFinite(row.value) ? `${row.value}${row.unit}` : '--' }}</template>
          </el-table-column>
          <el-table-column prop="dasFlag" label="数采标记">
            <template slot-scope="{row}">{{ row.dasFlag || '--' }}</template>
          </el-table-column>
          <el-table-column prop="autoFlag" label="自动审核">
            <template slot-scope="{row}">{{ row.autoFlag || '--' }}</template>
          </el-table-column>
          <el-table-column prop="auditFlag" label="人工审核">
            <template slot-scope="{row}">{{ row.auditFlag || '--' }}{{ row.autoFlag && row.auditComment ? `(${row.auditComment})` : '' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <RegenHourDataDialog
      :site="site"
      :siteDevice="auditSiteDevice"
      :defaultUnitProp="defaultUnitProp"
    />
  </template>
</layout-content>
</template>

<script>
import LayoutContent from '../../../components/Layout/Content'
import AuditMainGrid from './AuditMainGrid'
import AuditMainChart from './AuditMainChart'
import {
  AUDIT_COMMIT,
  AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED,
  GET_COMPARE_TABLE_VISIBLE,
  PROCESS_PANEL_SAVE, SHOW_AUDIT_MAIN
} from './EventKeys'
import ProcessPanel from './ProcessPanel'
import BatchProcessPanel from './BatchProcessPanel'
import AuditRelatedChartsDialog from './AuditRelatedChartsDialog'
import {mapGetters} from 'vuex'
import BaseStore from '../../../components/BaseStore'
import RegenHourDataDialog from './RegenHourDataDialog'

export default {
  name: 'BaseManualAuditView',
  extends: BaseStore,
  components: {AuditRelatedChartsDialog, BatchProcessPanel, ProcessPanel, AuditMainChart, AuditMainGrid, LayoutContent, RegenHourDataDialog},
  props: {
    site: {
      required: true,
      type: Object
    },
    auditSiteDevice: {
      required: true,
      type: Object
    },
    conditions: {
      required: true,
      type: Object
    },
    stage: {
      required: true,
      type: Number
    },
    maxAuditStage: {
      required: true,
      type: Number
    },
    selectedFactorIds: {
      required: true,
      type: Array
    },
    auditRuleCategories: {
      required: true,
      type: Array
    },
    filterDeviceErrorFactorIds: {
      required: true,
      type: Array
    },
    qcStatus: {
      type: Array,
      default: () => []
    },
    filterQcErrorFactorIds: {
      type: Array,
      default: () => []
    },
    moreTabs: {
      type: Array,
      default: () => []
    },
    numberToCN: {
      required: true,
      type: Object
    },
    hasAuditBtn: {
      required: true,
      type: Number
    },
    dataTimes: {
      required: true,
      type: Array
    },
    dataList: {
      required: true,
      type: Array
    },
    showMiniChart: {
      type: String,
      default: 'miniChart'
    },
    onBackBtnClick: {
      required: true,
      type: Function
    },
    onAuditTimeChanged: {
      required: true,
      type: Function
    },
    onMonthAuditBtnClick: {
      required: true,
      type: Function
    },
    onBatchProcessBtnClick: {
      required: true,
      type: Function
    },
    onAuditSubmitBtnClick: {
      required: true,
      type: Function
    },
    onMonthAuditSubmitBtnClick: {
      required: true,
      type: Function
    },
    onBackReAuditBtnClick: {
      required: true,
      type: Function
    },
    compareChartWidth: {
      type: String,
      default: 'auto'
    },
    defaultUnitProp: {
      type: String,
      default: 'displayUnit'
    }
  },
  data: () => ({
    selectedTab: null,
    hideTabs: Object.freeze([]),
    compareChartVisible: true,
    compareTableVisible: true,
    currentRuleId: '',
    originalFactorIds: [],
    auditMainChartSelectedFactorIds: [],
    auditMainChartSelectedList: [],
    defectData: [],
    tableData: [],
    selectNoData: [],
    noData: [],
    noDataRecords: Object.freeze([]),
    ratioData: [],
    handleSelectionNoDataTime: [],
    manyRatio: '',
    centerDialogVisible: false,
    monthAuditDataMap: {},
    errMsg: '',
    flagDetailDialogVisible: false,
    flagDetails: Object.freeze([]),
    flagName: ''
  }),
  computed: {
    ...mapGetters({
      showSideNav: 'Profile/showSideNav'
    }),
    startDatePickerOptions () {
      return {
        disabledDate: time => this.conditions.endTime && time.getTime() > new Date(this.conditions.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => this.conditions.beginTime && time.getTime() < new Date(this.conditions.beginTime)
      }
    },
    timeSpan () {
      let {conditions: {beginTime, endTime}} = this
      let end = new Date(endTime).format('YYYY/MM/DD')
      let start = new Date(beginTime).format('YYYY/MM/DD')
      return (new Date(end).getTime() - new Date(start).getTime()) / 60000 / 60 / 24
    },
    newAuditRuleCategories () {
      if (this.qcStatus.length > 0) {
        return this.auditRuleCategories.concat([{
          id: 'DeviceError',
          name: '状态参数异常',
          chartType: 'miniChart',
          factorIds: [...new Set(this.filterDeviceErrorFactorIds)]
        }, {
          id: 'QcError',
          name: '质控异常',
          chartType: 'miniChart',
          factorIds: [...new Set(this.filterQcErrorFactorIds)]
        }])
      }
      return this.auditRuleCategories.concat([{
        id: 'DeviceError',
        name: '状态参数异常',
        chartType: 'miniChart',
        factorIds: [...new Set(this.filterDeviceErrorFactorIds)]
      }])
    },
    filterAuditRuleCategories: {
      get () {
        let auditRuleCategories = this.newAuditRuleCategories.concat(this.moreTabs)
        auditRuleCategories = auditRuleCategories.filter(auditRuleCategory => auditRuleCategory.chartType)

        let auditRuleFlagMap = {}
        let auditRuleFactorMap = {}

        auditRuleCategories.forEach(({id, flags}) => {
          if (flags) {
            flags.forEach(flag => {
              auditRuleFlagMap[flag] = id
              auditRuleFactorMap[id] = {}
            })
          }
        })

        this.dataList.reduce((auditRuleFactorMap, {id: factorId, data}) => data.reduce((auditRuleFactorMap, {autoFlag}) => autoFlag ? autoFlag.split('|').reduce((auditRuleFactorMap, flag) => {
          let auditRuleCategoryId = auditRuleFlagMap[flag]

          if (auditRuleCategoryId) {
            auditRuleFactorMap[auditRuleCategoryId][factorId] = true
          }

          return auditRuleFactorMap
        }, auditRuleFactorMap) : auditRuleFactorMap, auditRuleFactorMap), auditRuleFactorMap)

        return auditRuleCategories.map(auditRuleCategory => {
          let backData = {
            ...auditRuleCategory,
            keys: 0
          }
          if (auditRuleFactorMap[auditRuleCategory.id]) {
            backData.factorIds = auditRuleCategory.id === 'DeviceError' ? [...new Set(this.filterDeviceErrorFactorIds)] : Object.freeze(Object.keys(auditRuleFactorMap[auditRuleCategory.id]))
          }
          if (this.currentRuleId === auditRuleCategory.id) {
            return {
              ...backData,
              isClick: !auditRuleCategory.isClick
            }
          }
          return {
            ...backData,
            isClick: false
          }
        }).sort((x, y) => {
          let a = x.factorIds ? x.factorIds.length : -1
          let b = y.factorIds ? y.factorIds.length : -1

          return b - a
        })
      },
      set (val) {}
    },
    causeOptions () {
      return [{
        label: '断电',
        value: 1
      }, {
        label: '例行运维',
        value: 2
      }, {
        label: '不可抗力',
        value: 4
      }, {
        label: '仪器故障/软件死机',
        value: 8
      }, {
        label: '正常缺失',
        value: 16
      }]
    }
  },
  methods: {
    onSelectionChange (factorIds, flag) {
      this.selectedTab = null

      if (flag !== false) {
        this.$emit('update:showMiniChart', 'miniChart')
      }
      this.originalFactorIds = JSON.parse(JSON.stringify([...factorIds]))

      let auditRuleCategory = this.filterAuditRuleCategories.find(el => el.isClick)
      if (auditRuleCategory) {
        auditRuleCategory.isClick = false
        this.onAuditRuleCategoryClick(auditRuleCategory)
      } else {
        this.auditMainChartSelectedFactorIds = [...factorIds]
      }
    },
    onAuditNumClick (dataList, flagName) {
      this.flagDetails = Object.freeze(dataList)
      this.flagName = flagName
      this.flagDetailDialogVisible = true
    },
    onProcessPanelSave () {
      this.auditMainChartSelectedList = []
    },
    onAuditRuleCategoryClick (auditRuleCategory) {
      auditRuleCategory.isClick = !auditRuleCategory.isClick
      this.currentRuleId = auditRuleCategory.id
      let {id} = auditRuleCategory

      if (id === this.showMiniChart && id !== 'miniChart') {
        this.selectedTab = null
        this.$emit('update:showMiniChart', 'miniChart')
        return
      }

      this.selectedTab = id
      this.$emit('update:showMiniChart', auditRuleCategory.chartType)

      let {factorIds} = auditRuleCategory
      if (!factorIds) {
        if (this.originalFactorIds.length === 0) {
          this.auditMainChartSelectedFactorIds = []
          setTimeout(() => {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [])
          }, 0)
        } else {
          this.auditMainChartSelectedFactorIds = [...this.originalFactorIds]
          setTimeout(() => {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [...this.originalFactorIds])
          }, 0)
        }
        this.setTabsScroll(auditRuleCategory)
        this.setHideTabs()
        return
      }
      // 如果选中
      if (auditRuleCategory.isClick) {
        // 有该异常数据
        if (factorIds && factorIds.length > 0) {
          // 未选择表格数据
          if (this.originalFactorIds.length === 0) {
            this.auditMainChartSelectedFactorIds = [...factorIds]
            setTimeout(() => {
              this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [...factorIds])
            }, 0)
          } else {
            // 已选表格数据 取其交集
            let originalFactorIdsMap = this.originalFactorIds.reduce((map, el) => {
              map[el] = el
              return map
            }, {})
            let filterFactorIds = factorIds.filter(el => originalFactorIdsMap[el])

            // 交集大于0 异常图表显示交集的数据 否则显示空图表
            if (filterFactorIds.length > 0) {
              this.auditMainChartSelectedFactorIds = [...filterFactorIds]
              setTimeout(() => {
                this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [...filterFactorIds])
              }, 0)
            } else {
              this.auditMainChartSelectedFactorIds = []
              setTimeout(() => {
                this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [])
              }, 0)
            }
          }
        } else if (factorIds.length === 0) {
          // 未选中表格数据且已选异常无异常因子
          this.auditMainChartSelectedFactorIds = []
          setTimeout(() => {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [])
          }, 0)
        }
      } else {
        this.currentRuleId = '--'
        auditRuleCategory.isClick = false
        // 取消选中时 表格选中数据为0 则无图表 有选中表格数据则显示已选中表格数据异常的图表
        if (this.originalFactorIds.length === 0) {
          this.auditMainChartSelectedFactorIds = []
          setTimeout(() => {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [])
          }, 0)
        } else {
          this.auditMainChartSelectedFactorIds = [...this.originalFactorIds]
          setTimeout(() => {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, [...this.originalFactorIds])
          }, 0)
        }
      }

      this.setTabsScroll(auditRuleCategory)
      this.setHideTabs()
    },
    onMoreTabClick (auditRuleCategory) {
      this.onAuditRuleCategoryClick(auditRuleCategory)
    },
    setTabsScroll (auditRuleCategory) {
      let index = this.filterAuditRuleCategories.indexOf(auditRuleCategory)

      if (index === -1) {
        return
      }

      let {$refs} = this
      let tabBar = $refs['tab-bar-inner']
      let tab = tabBar.children[index]
      let scrollLeft = tabBar.scrollLeft
      let tabLeft = tab.offsetLeft

      if (tabLeft < scrollLeft) {
        tabBar.scrollLeft = tabLeft
      } else {
        let tabRightX = tabLeft + tab.offsetWidth
        let tabBarWidth = tabBar.clientWidth

        if (tabRightX > (scrollLeft + tabBarWidth)) {
          tabBar.scrollLeft = tabRightX - tabBarWidth + 1
        }
      }
    },
    setHideTabs () {
      let {$refs, filterAuditRuleCategories} = this
      let tabBar = $refs['tab-bar-inner']

      if (!tabBar) {
        return
      }

      let tabs = [...tabBar.children]
      let left = tabBar.scrollLeft + 1
      let right = left + tabBar.clientWidth - 2
      let hideTabs = []

      tabs.forEach((tab, index) => {
        let {offsetLeft} = tab

        if (offsetLeft >= right || (offsetLeft + tab.offsetWidth) <= left) {
          hideTabs.push(filterAuditRuleCategories[index])
        }
      })

      this.hideTabs = Object.freeze(hideTabs)
    },
    onCompareTableCtrlClick () {
      this.compareTableVisible = !this.compareTableVisible
      this.$eventBus.emit(GET_COMPARE_TABLE_VISIBLE, this.compareTableVisible)

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 0)
    },
    onCompareChartCtrlClick () {
      this.compareChartVisible = !this.compareChartVisible

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 0)
    },
    // 多选缺失原因
    handleSelectionChange (val) {
      this.handleSelectionNoDataTime = JSON.parse(JSON.stringify(val))
    },
    // 多选缺失原因后 替换缺失表格数据同时重新计算捕集率
    manyRatioChange () {
      let {handleSelectionNoDataTime, tableData, manyRatio} = this
      let tableDataMap = tableData.reduce((map, el) => {
        map[el.dataTime] = el

        return map
      }, {})

      handleSelectionNoDataTime.forEach(el => {
        tableDataMap[el.dataTime].cause = manyRatio
      })
      this.tableData = Object.values(tableDataMap)
      setTimeout(() => {
        this.manyRatio = ''
        this.handleSelectionNoDataTime = []
        this.ratioChange()
      }, 10)
    },
    showElDiolog () {
      let {conditions: {auditTime}} = this
      let deviceId = this.auditSiteDevice.id

      this.$api.NoData.getNoData(auditTime, deviceId).then(data => {
        let temp = {}
        this.noDataRecords = Object.freeze(window.structuredClone(data))

        // 统计出某时段 所有因子都没有数据的时段数据（即补全数据的时段
        this.dataList.forEach(el => {
          let defectData = el.defectData
          if (defectData && defectData.length > 0) {
            defectData.forEach(item => {
              if (!temp[item.dataTime]) {
                temp[item.dataTime] = 0
              }
              temp[item.dataTime] = temp[item.dataTime] + 1
            })
          }
        })

        let flag = false
        for (let key in temp) {
          if (temp[key] === this.dataList.length) {
            flag = true
          }
        }
        let defectData = this.dataList[0] ? (this.dataList[0].defectData ? this.dataList[0].defectData : []) : []
        this.defectData = defectData

        // 一审 无已完成处理的缺失数据 所有因子都缺失
        if (this.stage <= 1 && data.length === 0 && flag && (!this.auditSiteDevice.auditInfos || this.auditSiteDevice.auditInfos.length === 0)) {
          this.getRatio(defectData)
          this.centerDialogVisible = true
        }
      }).catch(console.error)
    },
    openNoDataEditor () {
      let {conditions: {auditTime}} = this
      let deviceId = this.auditSiteDevice.id

      this.$api.NoData.getNoData(auditTime, deviceId).then(data => {
        this.noData = data
        this.getRatio(this.defectData)
        this.centerDialogVisible = true
      }).catch(console.error)
    },
    ratioChange () {
      let reduceDenominator = 0
      this.tableData.forEach(el => {
        if (el.cause <= 4 && el.cause !== '') {
          reduceDenominator += 1
        }
      })
      this.ratioData = this.ratioData.map(el => {
        let temp = el
        if (this.noData.length === 0) {
          temp.reduceDenominator = reduceDenominator
          temp.gatherRate = isNaN(temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)) ? 0 : temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)
        } else {
          temp.reduceDenominator = reduceDenominator
          temp.gatherDenominator = 24
          temp.gatherRate = isNaN(temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)) ? 0 : temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)
        }

        return temp
      })
    },
    getRatio (defectData) {
      let {auditSiteDevice, conditions} = this
      this.$api.Audit.getRatio(auditSiteDevice.id, conditions.auditTime).then(data => {
        this.noDataRatioFormat(data, defectData)
      }).catch(console.error)
    },
    noDataRatioFormat (data, defectData) {
      let siteId = this.site.id
      let deviceId = this.auditSiteDevice.id
      // console.log(this.dataList, siteId, deviceId, data)

      let tableData = defectData.reduce((map, el) => {
        if (!map[el.dataTime]) {
          map[el.dataTime] = {
            dataTime: el.dataTime,
            siteId: siteId,
            siteDeviceId: deviceId,
            cause: ''
          }
        }

        return map
      }, {})

      let {noData} = this
      if (noData.length > 0) {
        noData.forEach(el => {
          let dataTime = new Date(el.dataTime + ':00:00').format('YYYY/MM/DD HH:00:00')
          tableData[dataTime].cause = el.cause
        })
      }

      let dataListMap = this.dataList.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})

      let ratioData = []
      for (let key in data) {
        ratioData.push({
          factorName: dataListMap[key] ? dataListMap[key].name : '--',
          factorId: dataListMap[key] ? dataListMap[key].id : null,
          ...data[key],
          reduceDenominator: 0
        })
      }

      this.ratioData = ratioData
      this.tableData = Object.values(tableData)
    },
    handleSelectionNoData (val) {
      this.selectNoData = val
    },
    saveNoData () {
      let {tableData, conditions: {auditTime}} = this
      let deviceId = this.auditSiteDevice.id
      let flag = true
      tableData.forEach(el => {
        if (el.cause === '') {
          flag = false
        }
      })

      if (!flag && this.noData.length === 0) {
        this.$notify.error({
          title: '错误',
          position: 'bottom-right',
          message: '请完成所有缺失数据原因的选择'
        })
        return false
      }

      let noDataRecords = tableData.map(el => {
        return {
          dataTime: el.dataTime,
          cause: el.cause,
          siteDeviceId: el.siteDeviceId,
          siteId: el.siteId
        }
      })

      if (new Date(auditTime).getTime() > new Date().getTime() - 86400000) {
        this.$notify.error({
          title: '错误',
          position: 'bottom-right',
          message: '超出审核有效时间'
        })
        return false
      }

      this.$api.NoData.saveNoData({siteDeviceId: deviceId, auditTime: auditTime, noDataRecords: noDataRecords}).then(res => {
        this.centerDialogVisible = false
        this.noDataRecords = Object.freeze(noDataRecords)
      }).catch(console.error)
    },
    onFullScreenBtnClick () {
      this.$store.commit('Profile/showSideNav', !this.showSideNav)
      setTimeout(() => {
        let event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      }, 0)
    },
    onBackAuditedBtnClick () {
      this.$confirm(`此操作退回当前已审核的仪器, 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.changeLoadStatus(true)

        this.$api.Audit.backAudited(this.auditSiteDevice.auditId).then(() => {
          this.$eventBus.emit(AUDIT_COMMIT)
          this.$parent.isShow = false
          this.$eventBus.emit(SHOW_AUDIT_MAIN)
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }).catch(() => {})
    },
    getMonthAuditList () {
      this.$api.Audit.getMonthAuditList({
        auditMonthTime: new Date(this.conditions.auditTime).format('YYYY/MM'),
        siteDeviceId: this.auditSiteDevice.id
      }).then(data => {
        this.monthAuditDataMap = Object.freeze(data.reduce((map, el) => {
          map[el.auditMonthTime] = el
          return map
        }, {}))
      }).catch(console.error)
    }
  },
  watch: {
    filterAuditRuleCategories () {
      setTimeout(() => {
        this.setHideTabs()
      }, 0)
    },
    dataList (val, oldVal) {
      if (val) {
        this.showElDiolog()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.setHideTabs()
    }, 0)

    this.$eventBus.on(PROCESS_PANEL_SAVE, this.onProcessPanelSave)
    window.addEventListener('resize', this.setHideTabs)
    this.getMonthAuditList()
  },
  beforeDestroy () {
    this.$eventBus.off(PROCESS_PANEL_SAVE, this.onProcessPanelSave)
    window.removeEventListener('resize', this.setHideTabs)
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  /deep/ .layout-content-body-inner {
    display: grid;
    grid-template: {
      columns: var(--manual-layout-grid-columns);
      rows: var(--manual-layout-grid-rows);
    };
    grid-row-gap: var(--manual-layout-grid-row-gap);
    padding: 0 .8em;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }
  }
}

.audit-tab-bar {
  --more-tabs-size: 24px;

  display: grid;
  grid-template-columns: auto var(--more-tabs-size);
  grid-column-gap: 10px;
  align-items: center;

  > * {
    min: {
      width: 0;
      height: 0;
    };
  }

  > .audit-tab-bar-inner {
    position: relative;
    display: flex;
    gap: 10px;
    height: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;

    > li {
      font-size: 13px;
      display: grid;
      grid-template-rows: var(--grid-template-rows);
      grid-row-gap: 2px;
      align-items: center;
      flex-shrink: 0;
      width: 100px;
      height: 100%;
      line-height: 1;
      padding: 6px 5px;
      border: 1px solid #DCDFE6;
      text-align: center;
      cursor: pointer;
      user-select: none;

      &:hover {
        background-color: #F5F7FA;
      }

      &:active {
        background-color: #e5e7eA;
      }

      &.selected {
        color: #5B92FF;
        border-color: currentColor;
        box-shadow: inset 0 0 10px 1px rgba(91, 146, 255, .15);
      }

      * {
        cursor: pointer;
      }
    }
  }

  .more-tabs {
    font-size: calc(var(--more-tabs-size) - 4px);
    height: var(--more-tabs-size);
    cursor: pointer;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #67C23A;
  }
}

.compare-chart-ctrl,
.compare-chart-wrapper {
  grid-row: var(--row-span);
}

.compare-chart-ctrl {
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 2;

  .compare-chart-ctrl-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 88px;
    cursor: pointer;

    &:hover {
      background-color: #eef7fe;
    }
  }
}

.compare-chart-wrapper {
  grid-column: 3;
  overflow: hidden;
}
.el-dialog__wrapper /deep/ .el-dialog__header {
  padding: 10px 15px;
}
.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 5px 15px;
  overflow: auto;
}
.el-dialog__wrapper /deep/ .el-dialog__footer {
  padding: 10px 15px;
}

.comment-wrapper {
  position: relative;
  width: 320px;
  margin: 0;
  padding: 0;

  .comment-btn {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
}

.error-msg {
  color: red;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/BaseManualAuditView.vue